<template>
  <b-card v-if="showChart"
          class="w-100 mx-1 my-2 text-center"
          border-variant="dark"
          header-text-variant="white"
          header-tag="header"
          header-bg-variant="dark"
          >
    <template v-slot:header>
      <span style="font-size: 14px; font-weight: bold;">{{chartItem.chartName}}</span>
      <!--
      <b-button
          style="position: absolute; top:0px; right:-6px;"
          class="text-right mx-2 px-1 py-0" aria-label="Close" variant="dark" size="sm">
        <font-awesome-icon icon="times-circle"/>
      </b-button>
      -->
    </template>

    <line-chart height="400px"
                :data="chartItem.chartData"
                :colors="chartItem.chartColor"
                :dataset="{borderWidth: 1, lineTension: 0, pointRadius: 1}"
                :xmin="chartItem.chartXMin"
                :xmax="chartItem.chartXMax"
                :curve="false"
                :discrete="false"
                :download="{background: '#fff'}"
                :library="chartItem.chartOptions"
                :messages="{empty: 'No data'}"/>

  </b-card>
</template>

<script>
import measurementUtil from "../../lib/MeasurementUtil";
import {mapActions} from "vuex";
import measurementTypes from "../../lib/MeasurementTypes";
import protocolTypes from "../../lib/ProtocolTypes"

export default {
  name: "MeasurementChart",
  props: ['chartTemplate', 'session', 'measurementData'],
  data() {
    return {
      chartItemsClass: 'w-50 p-2 text-center',
    }
  },
  created () {

  },
  computed: {

    showChart: function() {

      if(!this.chartTemplate)
        return false;

      return this.chartTemplate.hideWhenEmpty ? this.chartItem.chartData.length > 0 : true;
    },

    chartItem: function () {

      if (this.chartTemplate && this.session) {

        let targetData = null;
        let showTarget = this.chartTemplate.showTargetIntensity && protocolTypes.hasTargetIntensity(this.session.protocolType);
        if(showTarget) {
          targetData = this.measurementData.data.find(x => x.id === measurementTypes.StepPowerIntensity);
          if (!targetData) {
            targetData = this.measurementData.data.find(x => x.id === measurementTypes.StepSpeedIntensity);
          }
        }

        let protocolData = this.chartTemplate.showProtocolPhases && this.measurementData.protocolData;
        let showProtocolRegions = protocolData && protocolData.phases && protocolData.phases.length > 0;
        if(!showProtocolRegions) {
          protocolData = null;
        }

        let self = this;
        let measurements = [];
        this.chartTemplate.measurementIds.forEach(function(id) {
            measurements.push(self.measurementData.data.find(x => x.id === id));
        });

        return this.createChart(this.chartTemplate.chartName, measurements, targetData, protocolData);
      }

      return {
        chartName: '',
        chartColor: [],
        chartXMin: 0,
        chartXMax: 0,
        chartData: [],
        chartOptions: {
          scales: {
            yAxes: [],
            xAxes: []
          }
        },
      };

    },
  },
  methods: {
      ...mapActions({}),

      createSeries: function (measurement) {

        let ticks = {
          //suggestedMin: measurement.measurementType.rangeMin,
          min: 0,
          suggestedMax: measurement.measurementType.rangeMax,
          stepSize: measurement.measurementType.stepSize ?? 1,
          fontColor: measurement.color,
          padding: 2
        };

        if(measurement.metrics && measurement.metrics.max && measurement.measurementType.rangeMax) {
          if(measurement.metrics.max < measurement.measurementType.rangeMax * 0.75) {
            ticks.max = measurement.metrics.max;
          } else {
            ticks.max = Math.max(measurement.metrics.max, measurement.measurementType.rangeMax);
          }

          ticks.max = Math.ceil(ticks.max + ticks.stepSize);

          ticks.max +=  ticks.stepSize - ticks.max % ticks.stepSize;

        } else if (ticks.suggestedMax && ticks.stepSize) {
          ticks.suggestedMax += ticks.stepSize * 2;
        }

        return {
          name: measurement.shortNameWithUnits,
          color: measurement.color,
          xMin: 0,
          xMax: measurement.elapsedSeconds,
          yAxes: {
            id: measurement.id,
            type: 'linear',
            ticks: ticks,
            gridLines: {
              drawOnChartArea: false,
              drawBorder: true,
              color: '#555555',
              z: -1,
            },
            position: measurement.yAxisPosition ?? 'left',
            offset: false,
          },
          chartData: measurement.chartData ?? [],
          library: {
            fill: measurement.fill,
            backgroundColor: measurement.fillColor,
            pointRadius: measurement.fill ? 0 : 1,
            pointHoverRadius: 1,
            yAxisID: measurement.id,
          }
        };

      },

      createChart: function (chartName, measurements, targetData, protocolData) {

        let self = this;

        measurements = measurements.filter(x => x !== undefined && x != null);

        if(measurements.length > 0) {
          if (!chartName) {
            chartName = measurements[0].name;
          }

          if(targetData) {
            measurements.unshift(targetData);
          }
        }

        let series = measurements.map(function (item) {
          return self.createSeries(item);
        });
        let seriesData = series.map(function (item) {
          return {
            name: item.name,
            data: item.chartData,
            library: item.library
          };
        });
        let colors = measurements.map(function (item) {
          return item.color;
        });
        let yAxes = series.map(function (item) {
          return item.yAxes;
        });
        let xMax = series.reduce(function (accumulator, item) {
          return accumulator > item.xMax ? accumulator : item.xMax;
        }, 0);

        let annotations = [];
        if (protocolData && protocolData.phases && protocolData.phases.length > 0) {
          for (let phase of protocolData.phases) {

            let color = 'rgb(250, 250, 250, 0.6)';
            if (phase.phaseType == 'warmUp' ||
                phase.phaseType == 'coolDown' ||
                phase.phaseType == 'restingSettleIn'
            ) {
              color = 'rgb(239, 245, 250, 0.8)';
            }

            annotations.push({
              type: 'box',
              xScaleID: 'x-axis-0',
              xMin: phase.startTime,
              xMax: phase.startTime + phase.duration,
              borderColor: 'transparent',
              borderWidth: 0,
              backgroundColor: color,
            });
          }
        }

        return {
          chartName: chartName ?? '',
          chartColor: colors,
          chartXMin: 0,
          chartXMax: xMax,
          chartData: seriesData,
          chartOptions: {
            legend: {
              position: 'top',
              align: 'end'
            },
            chartArea: {
              backgroundColor: 'rgba(248, 248, 248)',
            },
            annotation: {
              drawTime: 'beforeDatasetsDraw',
              annotations: annotations,
            },
            scales: {
              yAxes: yAxes,
              xAxes: [{
                title: {
                  display: false,
                },
                beginAtZero: true,
                ticks: {
                  callback: function (value) {
                    //formats x axis seconds as hh:mm:ss
                    return measurementUtil.toHHMMSS(value);
                  }
                }
              }]
            }
          },
        };

      },
    }
}
</script>

<style scoped>

</style>